// InputFullBorder
import { useState } from 'react';
import SelectCountryList from './../Select/SelectCountryList';

const InputFullBorder = ({
    onChange,
    setValue,
    value,
    regionObj,
    label,
    icon,
    typeInput,
}) => {
    const [focus, setFocus] = useState(value === "" ? false : true);
    const [touch, setTouch] = useState(false);
    const [filled, setFilled] = useState(value === "" ? false : true);

    if (typeInput === "allCity") {
        return (
            <div className={`inputFullBorder inputFullBorder--select ${focus ? "focus" : ""} ${value ? "filled" : ""}`}>
                <div className="inputFullBorder__labelBox">
                    <label className={`inputFullBorder__label ${focus ? "focus" : ""}`}>
                        {label}
                    </label>
                </div>

                <div className="inputFullBorder__selectWrap">
                    {icon && (
                        <div className="inputFullBorder__iconBox inputFullBorder__iconBox--select">
                            {icon}
                        </div>
                    )}

                    <SelectCountryList
                        setValue={(nextValue) => {
                            setValue(nextValue);
                            setFilled(!!nextValue);
                        }}
                        regionObj={regionObj}
                        value={value}
                        label=""
                        setTouch={setTouch}
                        setFocus={setFocus}
                        setFilled={setFilled}
                        focus={focus}
                    />
                </div>

                {touch && !value && (
                    <div className="inputFullBorder__hint">
                        Поле {label} обязательно
                    </div>
                )}
            </div>
        );
    }

    return (
        <div className={`inputFullBorder ${focus ? "focus" : ""} ${filled ? "filled" : ""}`}>
            <div className="inputFullBorder__labelBox">
                <label className={`inputFullBorder__label ${focus ? "focus" : ""}`}>
                    {label}
                </label>
            </div>

            {icon && (
                <div className="inputFullBorder__iconBox">
                    {icon}
                </div>
            )}

            <input
                className={`inputFullBorder__input ${focus ? "focus" : ""}`}
                onChange={onChange}
                value={value}
                type="text"
                onFocus={() => {
                    setFocus(true);
                    setTouch(true);
                }}
                onBlur={(e) => {
                    if (e.target.value === "") {
                        setFocus(false);
                        setFilled(false);
                    } else {
                        setTouch(false);
                        setFilled(true);
                    }
                }}
            />
        </div>
    );
};

export default InputFullBorder;